var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gallery-wrapper" }, [
    _vm.imageUrls.length > 0
      ? _c(
          "div",
          {
            ref: "gallery",
            staticClass: "gallery",
            attrs: { "data-item-id": _vm.itemId },
          },
          [
            _vm.imageUrls.length > 1 && _vm.enableCarousel
              ? [
                  _c("lazy-img", {
                    ref: { itemLazyImage: !_vm.disableLazyLoad },
                    staticClass: "mainImg",
                    attrs: {
                      "image-url": _vm.imageOrItemImage,
                      alt: _vm.getAltText(_vm.imageUrls[0]),
                      "image-alt": _vm.getImageAltText(_vm.imageUrls[0]),
                      "fallback-alt": _vm.alt,
                      id: _vm.getId(_vm.imageUrls[0]),
                      title: _vm.getTitleText(_vm.imageUrls[0]),
                      width: _vm.getImageWidth(_vm.imageUrls[0]),
                      height: _vm.getImageHeight(_vm.imageUrls[0]),
                      "show-ai-hint": false,
                      "picture-class": "mainImg",
                    },
                  }),
                  _vm._v(" "),
                  _c("lazy-img", {
                    ref: { itemLazyImage: !_vm.disableLazyLoad },
                    staticClass: "secondImg",
                    attrs: {
                      "image-url": _vm.imageUrls[1].url,
                      alt: _vm.getAltText(_vm.imageUrls[1]),
                      "image-alt": _vm.getImageAltText(_vm.imageUrls[1]),
                      "fallback-alt": _vm.alt,
                      id: _vm.getId(_vm.imageUrls[1]),
                      title: _vm.getTitleText(_vm.imageUrls[1]),
                      width: _vm.getImageWidth(_vm.imageUrls[1]),
                      height: _vm.getImageHeight(_vm.imageUrls[1]),
                      "show-ai-hint": false,
                      "picture-class": "secondImg",
                    },
                  }),
                ]
              : [
                  _c("lazy-img", {
                    ref: { itemLazyImage: !_vm.disableLazyLoad },
                    staticClass: "mainImg",
                    attrs: {
                      "image-url": _vm.imageOrItemImage,
                      id: _vm.getId(_vm.imageUrls[0]),
                      "image-alt": _vm.getImageAltText(_vm.imageUrls[0]),
                      "fallback-alt": _vm.alt,
                      alt: _vm.getAltText(_vm.imageUrls[0]),
                      title: _vm.getTitleText(_vm.imageUrls[0]),
                      width: _vm.getImageWidth(_vm.imageUrls[0]),
                      height: _vm.getImageHeight(_vm.imageUrls[0]),
                      "show-ai-hint": false,
                      "picture-class": "mainImg",
                    },
                  }),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("span", {
      ref: "dots",
      staticClass: "dots",
      class: { "d-none": !_vm.dotsVisible },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }